import { FALLBACK_SCHEDULE } from './calendar.jsx';

// Same fail-open idiom as extractPhrases in aiUtils.jsx: the Netlify function
// (netlify/functions/get-schedule.js) already fails open to its own copy of
// the fallback schedule, but this covers the function being unreachable
// entirely (offline dev, a Netlify outage) so the Timeline page is never blank.
export async function fetchSchedule() {
  try {
    const response = await fetch('/.netlify/functions/get-schedule');
    if (!response.ok) return FALLBACK_SCHEDULE;
    const data = await response.json();
    return Array.isArray(data.events) && data.events.length ? data.events : FALLBACK_SCHEDULE;
  } catch (e) {
    console.error('fetchSchedule failed', e);
    return FALLBACK_SCHEDULE;
  }
}
